import { useIntersectionObserver, useToggle } from "@react-hookz/web";
import type { ReactNode } from "react";
import React, { useEffect, useRef } from "react";
import { useSdkContext } from "scmp-sdk/components";

import { useIsFirstTimeVisitDashboardWidget } from "./hooks";
import { Container } from "./styles";
import type { Props as DashboardTooltipsProps } from "./tooltips";
import { DashboardTooltips } from "./tooltips";

export type Props = Pick<DashboardTooltipsProps, "tooltipRenders"> & {
  children: ReactNode;
  className?: string;
};

export const DashboardWidget: React.FunctionComponent<Props> = ({
  children,
  className,
  tooltipRenders,
}) => {
  const anchorElement = useRef<HTMLDivElement>(null);
  const [isTooltipVisible, setIsTooltipVisible] = useToggle(true);
  const observer = useIntersectionObserver(anchorElement);
  const { config, handleOpenLoginDialog, hasAcceptedGDPR, user } = useSdkContext();

  const { setIsFirstTime } = useIsFirstTimeVisitDashboardWidget();

  useEffect(() => {
    if (!hasAcceptedGDPR) return;
    setIsFirstTime(false);
  }, [hasAcceptedGDPR, setIsFirstTime]);

  useEffect(() => {
    setIsTooltipVisible(observer?.isIntersecting);
  }, [observer?.isIntersecting, setIsTooltipVisible]);

  return (
    <DashboardTooltips isTooltipVisible={isTooltipVisible} tooltipRenders={tooltipRenders}>
      <Container
        className={className}
        onClick={() => {
          // setTimeout 0 is a hack for quick INP
          setTimeout(() => {
            if (user) {
              const url = new URL(`${config.accounts.host}`);
              window.open(url.toString(), "_blank");
            } else {
              handleOpenLoginDialog({
                destination: globalThis.location.href,
                ga4CustomParameter: {
                  trigger_point: "header",
                },
              });
            }
          }, 0);
        }}
        ref={anchorElement}
      >
        {children}
      </Container>
    </DashboardTooltips>
  );
};
